module.exports = __webpack_public_path__ + "static/media/view-contract-icon.6696828a.svg";